import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import SydButton from '../../../../commonDesign/Button'
import SydInput from '../../../../commonDesign/SydInput'
import SydLabel from '../../../../commonDesign/SydLabel'
import { useCreateViewVersion } from '../../../../../api/abundanceEngine'
import NewVersionModal from './NewVersionModal'
import VersionSelect from './VersionSelect'

function WorkingVersionBar ({
  viewId,
  workingVersionId,
  onWorkingVersionChange,
  versionDescription,
  onVersionDescriptionChange,
  getCurrentContent,
  onAlert,
  isComparing,
  onCompareToggle
}) {
  const createVersion = useCreateViewVersion()
  const [newVersionModalOpen, setNewVersionModalOpen] = useState(false)

  const handleCreateVersion = useCallback(async ({ description }) => {
    if (!viewId) return
    try {
      const latestContent = getCurrentContent?.() || ''
      const result = await createVersion.mutateAsync({
        viewId,
        content: latestContent,
        description
      })
      if (result?.viewVersionId) {
        onWorkingVersionChange(result.viewVersionId)
      }
      setNewVersionModalOpen(false)
      onAlert?.({ severity: 'success', message: 'New version created' })
    } catch (err) {
      onAlert?.({ severity: 'error', message: err?.message || 'Failed to create version' })
    }
  }, [viewId, getCurrentContent, createVersion, onWorkingVersionChange, onAlert])

  if (!viewId) {
    return (
      <div className='flex-1' />
    )
  }

  return (
    <div className='flex-1 flex gap-sm items-center p-2 radius-lg border bg-neutral-100 border-neutral-300'>
      <div className='mt-2'>
        <SydButton
          variant='primary'
          type='button'
          onClick={() => setNewVersionModalOpen(true)}
          icon='add'
        >
          New Version
        </SydButton>
      </div>
      <div>
        <VersionSelect
          viewId={viewId}
          label='Working Version'
          value={workingVersionId}
          onChange={onWorkingVersionChange}
          placeholder='Version'
          size='sm'
        />
      </div>
      <div className='flex-1'>
        <SydLabel label='Version Description'>
          <SydInput
            placeholder='Version Description'
            size='sm'
            value={versionDescription || ''}
            onChange={(e) => onVersionDescriptionChange(e.target.value)}
          />
        </SydLabel>
      </div>
      {onCompareToggle && (
        <div className='mt-2'>
          <SydButton
            variant={isComparing ? 'primary' : 'secondary'}
            type='button'
            onClick={onCompareToggle}
            icon='compare_arrows'
            size='sm'
          >
            Compare
          </SydButton>
        </div>
      )}
      <NewVersionModal
        open={newVersionModalOpen}
        onClose={() => setNewVersionModalOpen(false)}
        onConfirm={handleCreateVersion}
        isProcessing={createVersion.isLoading}
      />
    </div>
  )
}

WorkingVersionBar.propTypes = {
  viewId: PropTypes.number,
  workingVersionId: PropTypes.string,
  onWorkingVersionChange: PropTypes.func.isRequired,
  versionDescription: PropTypes.string,
  onVersionDescriptionChange: PropTypes.func.isRequired,
  getCurrentContent: PropTypes.func,
  onAlert: PropTypes.func,
  isComparing: PropTypes.bool,
  onCompareToggle: PropTypes.func
}

export default WorkingVersionBar
